/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import jump from "src/utils/jump";
import jumpSmooth from "src/utils/jumpSmooth";


class ScrollManager {
    /**
     *
     * @param element
     * @param callback
     */
    observeTitle(element, callback) {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0] && entries[0].isIntersecting) {
                    callback();
                }
            },
            {
                threshold: 0.5,
                rootMargin: "-200px 0px -70% 0px",
            }
        );
        observer.observe(element);
        return observer;
    }

    /**
     *
     * @param element
     * @param callback
     */
    observeTable(element, callback) {
        const observer = new IntersectionObserver(
            entries => {
                callback(entries[0] && entries[0].isIntersecting);
            },
            {
                threshold: 0,
                rootMargin: "-200px 0px -50% 0px",
            }
        );
        observer.observe(element);
        return observer;
    }

    /**
     *
     * @param section
     */
    scrollToSection(section) {
        const element = document.getElementById("section-" + section.key);
        this.scrollToElement(element, 400);
    }

    /**
     *
     * @param id
     */
    scrollToId(id) {
        const element = document.getElementById(id);
        if (element) {
            this.scrollToElement(element);
        } else {
            this.scrollTop();
        }
    }

    /**
     *
     * @param element
     */
    scrollToElement(element, duration = 0, offset = 250) {
        if (element) {
            jump(element, { offset: -offset, duration });
        }
    }


    scrollToIdSmooth(id) {
        const element = document.getElementById(id);
        if (element) {
            this.scrollToElementSmooth(element);
        } else {
            this.scrollTop();
        }
    }

    /**
     *
     * @param element
     */
    scrollToElementSmooth(element, duration = 0, offset = 250) {
        if (element) {
            jumpSmooth(element, { offset: -offset, duration });
        }
    }


    /**
     *
     */
    scrollTop() {
        window.scrollTo(0, 0);
    }
}

const scrollManager = new ScrollManager();
export default scrollManager;
